import { type ExternalBankAccount } from '@webapp/platform/banking/entities/ExternalBankAccount'
import { useCreateExternalBankAccountFormPresenter } from './useCreateExternalBankAccountFormPresenter'
import { ExternalBankAccountForm } from '../../views/ExternalBankAccountForm'

export interface ICreateExternalBankAccountFormPresenterProps {
  /** Flag-derived by the FS (bill_pay && !FT_4280) — never read in-feature (BHV-013) */
  restrictTypeToOther: boolean
  /** FS-held: a create-another save remounts the form with the box checked (BHV-017) */
  initialCreateAnother?: boolean
  /** FS closes the modal, invalidates the audit query, reopens on createAnother (BHV-015/017) */
  onSuccess: (account: ExternalBankAccount, createAnother: boolean) => void
  onCancel: () => void
}

export const CreateExternalBankAccountFormPresenter = ({
  restrictTypeToOther,
  initialCreateAnother = false,
  onSuccess,
  onCancel,
}: ICreateExternalBankAccountFormPresenterProps) => {
  const {
    states: { isSubmitting },
    handlers: { handleSubmit },
  } = useCreateExternalBankAccountFormPresenter({
    restrictTypeToOther,
    onSuccess,
  })

  return (
    <ExternalBankAccountForm
      restrictTypeToOther={restrictTypeToOther}
      initialCreateAnother={initialCreateAnother}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  )
}

CreateExternalBankAccountFormPresenter.displayName =
  'CreateExternalBankAccountFormPresenter'
